export default import.meta.ROLLDOWN_FILE_URL_bsSD71_6uK7QSBiaRH8tIg